module.exports = __webpack_public_path__ + "static/media/Internal Medicine-NEw Patient Intake-2@3x.e640e98f.png";